import { useEffect } from "react";
import { motion, useScroll } from "framer-motion";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import PhotoSlot from "@/components/PhotoSlot";
import Etablissements from "@/components/Etablissements";
import Mecanisme from "@/components/Mecanisme";
import Pros from "@/components/Pros";
import Vision from "@/components/Vision";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const PAIR_A = ["/images/visage-lumiere.png", "/images/table-healthy.png"];
const PAIR_ALTS = {
  A: ["Lumière & présence", "Cuisine vivante"],
};

const PhotoPair = ({ imgs, alts, idBase }) => (
  <div className="wrap grid md:grid-cols-2 gap-4 md:gap-5 py-8 md:py-12">
    {imgs.map((src, i) => (
      <PhotoSlot key={src} src={src} index={`${idBase}${i}`} caption={alts[i]} ratio="aspect-[4/5]" speed={45 + i * 20} />
    ))}
  </div>
);

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  return (
    <motion.div
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 h-[3px] z-[85] origin-left"
      style={{ scaleX: scrollYProgress, background: "linear-gradient(90deg, #E8431F, #D6478E)" }}
    />
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="noise-overlay" aria-hidden="true" />
      <ScrollProgress />
      <Nav />
      <main>
        <Hero />
        <Mecanisme />
        <Etablissements />
        <PhotoPair imgs={PAIR_A} alts={PAIR_ALTS.A} idBase="a" />
        <Pros />
        <Vision />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
